export const skillsConstantsData = [
  {
    id: 2548,
    skill: "python",
    is_deleted: false,
  },
  {
    id: 2299,
    skill: "React.js",
    is_deleted: false,
  },

  // {
  //   id: 1440,
  //   skill: "Artificial Intelligence",
  //   is_deleted: false,
  // },

  // {
  //   id: 2062,
  //   skill: "Java",
  //   is_deleted: false,
  // },
  // {
  //   id: 1834,
  //   skill: "Data Science",
  //   is_deleted: false,
  // },
  // {
  //   id: 1464,
  //   skill: "Azure",
  //   is_deleted: false,
  // },
  // {
  //   id: 2016,
  //   skill: "HTML",
  //   is_deleted: false,
  // },
  // {
  //   id: 2547,
  //   skill: "CSS",
  //   is_deleted: false,
  // },
  // {
  //   id: 2326,
  //   skill: "Salesforce App Development",
  //   is_deleted: false,
  // },
  // {
  //   id: 2452,
  //   skill: "User Interface Design",
  //   is_deleted: false,
  // },
  // {
  //   id: 2450,
  //   skill: "User Experience Design",
  //   is_deleted: false,
  // },
  // {
  //   id: 1556,
  //   skill: "Cloud Computing",
  //   is_deleted: false,
  // },
  // {
  //   id: 2568,
  //   skill: "AWS",
  //   is_deleted: false,
  // },
  // {
  //   id: 1368,
  //   skill: ".NET",
  //   is_deleted: false,
  // },
  // {
  //   id: 2495,
  //   skill: "Web Security",
  //   is_deleted: false,
  // },
  // {
  //   id: 2094,
  //   skill: "LESS/Sass/SCSS",
  //   is_deleted: false,
  // },
];
